import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=4d356d9c&lang=pug"
import script from "./FooterContent.vue?vue&type=script&lang=ts"
export * from "./FooterContent.vue?vue&type=script&lang=ts"
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=4d356d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports